<div
    id="dashboard-sidebar-overlay"
    [ngClass]="{ active: (isOpenSidebar$ | async) && (isMobile$ | async) }"
    (click)="closeSidebar()"></div>
<app-dashboard-layout-sidebar></app-dashboard-layout-sidebar>
<div
    id="dashboard-content"
    [ngClass]="{ active: (isOpenSidebar$ | async), 'padding-container': (isOpenSidebar$ | async) }">
    <app-dashboard-layout-topbar></app-dashboard-layout-topbar>
    <router-outlet></router-outlet>
</div>
<button
    id="openMenu"
    [ngClass]="{ 'd-none': (isOpenSidebar$ | async) }"
    [full]="true"
    (click)="toggleSidebar()"
    appButtonIcon
    color="secondary"
    iconSize="small">
    <svg-icon src="assets/icons/Menu.svg"></svg-icon>
</button>
